<template>
    <component :is="`SPurchasing${type}`" v-bind="l10n" />
</template>

<script>
import l10n from '@core/mixins/l10n.js';
import SPurchasingItems1 from './components/items-1/template.vue';
import SPurchasingItems2 from './components/items-2/template.vue';

export default {
    name: 'SPurchasing',

    components: {
        SPurchasingItems1,
        SPurchasingItems2,
    },

    mixins: [l10n],

    props: {
        type: {
            type: String,
            default: 'Items2',
        },
        title: {
            type: String,
            default: null,
        },
        lead: {
            type: String,
            default: null,
        },
        background: {
            type: String,
            default: null,
        },
        settings: {
            type: Object,
            default: null,
        },
        purchasePageCTA: {
            type: Object,
            default: null,
        },
    },
};
</script>
